import { Record } from "immutable";

const EngagementRecord = Record({
  bubbleChart: {},
  commentId: null,
  comment: "",
  initComment: ""
});

class Engagement extends EngagementRecord {}

export default Engagement;



// WEBPACK FOOTER //
// ./src/models/Engagement.js